/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Plan_Discount_Form_Duration_HintInputs */

const en_admin_plan_discount_form_duration_hint = /** @type {(inputs: Admin_Plan_Discount_Form_Duration_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From the start of the membership`)
};

const de_admin_plan_discount_form_duration_hint = /** @type {(inputs: Admin_Plan_Discount_Form_Duration_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von Beginn der Mitgliedschaft.`)
};

const es_admin_plan_discount_form_duration_hint = /** @type {(inputs: Admin_Plan_Discount_Form_Duration_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde el inicio de la suscripción.`)
};

const fr_admin_plan_discount_form_duration_hint = /** @type {(inputs: Admin_Plan_Discount_Form_Duration_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dès le début de l'adhésion.`)
};

const nl_admin_plan_discount_form_duration_hint = /** @type {(inputs: Admin_Plan_Discount_Form_Duration_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vanaf de start van het lidmaatschap`)
};

const it_admin_plan_discount_form_duration_hint = /** @type {(inputs: Admin_Plan_Discount_Form_Duration_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dall'inizio dell'adesione.`)
};

const pt_br2_admin_plan_discount_form_duration_hint = /** @type {(inputs: Admin_Plan_Discount_Form_Duration_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde o início da assinatura.`)
};

const pl_admin_plan_discount_form_duration_hint = /** @type {(inputs: Admin_Plan_Discount_Form_Duration_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Od początku członkostwa.`)
};

const hu_admin_plan_discount_form_duration_hint = /** @type {(inputs: Admin_Plan_Discount_Form_Duration_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tagság kezdetétől.`)
};

const ro_admin_plan_discount_form_duration_hint = /** @type {(inputs: Admin_Plan_Discount_Form_Duration_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De la inceputul abonamentului.`)
};

/**
* | output |
* | --- |
* | "From the start of the membership" |
*
* @param {Admin_Plan_Discount_Form_Duration_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_plan_discount_form_duration_hint = /** @type {((inputs?: Admin_Plan_Discount_Form_Duration_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Plan_Discount_Form_Duration_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_plan_discount_form_duration_hint(inputs)
	if (locale === "de") return de_admin_plan_discount_form_duration_hint(inputs)
	if (locale === "es") return es_admin_plan_discount_form_duration_hint(inputs)
	if (locale === "fr") return fr_admin_plan_discount_form_duration_hint(inputs)
	if (locale === "nl") return nl_admin_plan_discount_form_duration_hint(inputs)
	if (locale === "it") return it_admin_plan_discount_form_duration_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_plan_discount_form_duration_hint(inputs)
	if (locale === "pl") return pl_admin_plan_discount_form_duration_hint(inputs)
	if (locale === "hu") return hu_admin_plan_discount_form_duration_hint(inputs)
	return ro_admin_plan_discount_form_duration_hint(inputs)
});
export { admin_plan_discount_form_duration_hint as "admin.plan_discount_form.duration_hint" }